import { Box, CircularProgress } from "@mui/material";
import type { ReactNode } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import type { Permission } from "@web/config/permissions";
import { hasPermission } from "@web/config/permissions";
import { useAuth } from "@features/auth/context/AuthContext";

export function ProtectedRoute() {
  const auth = useAuth();
  const location = useLocation();
  if (auth.isInitializing)
    return (
      <Box sx={{ minHeight: "100vh", display: "grid", placeItems: "center" }}>
        <CircularProgress aria-label="Restoring session" />
      </Box>
    );
  return auth.isAuthenticated ? (
    <Outlet />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
}

export function PublicRoute() {
  const auth = useAuth();
  if (auth.isInitializing) return null;
  return auth.isAuthenticated ? (
    <Navigate to="/dashboard" replace />
  ) : (
    <Outlet />
  );
}

export function PermissionRoute({
  permission,
  children,
}: {
  permission: Permission;
  children?: ReactNode;
}) {
  const { user } = useAuth();
  return hasPermission(user?.role, permission, user?.permissions) ? (
    (children ?? <Outlet />)
  ) : (
    <Navigate to="/unauthorized" replace />
  );
}
